import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { SearchService } from '../../search/services/search.service';

/**
 * Component providing a view of the user's current search information.
 */
@Component({
  selector: 'search-terms',
  templateUrl: './search-terms.component.html',
  styleUrl: './search-terms.component.css'
})
export class SearchTermsComponent implements OnInit {
	
	LOCALIZATION: any;
	searchHistory: any[] = [];
	concepts: any[] = [];
	
	constructor(
		private ngbmodalService: NgbActiveModal,
		private userService: UserService,
		private searchService: SearchService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		this.loadUserSearchHistory();	
	}
	
	/**
	 * Gets the most recent search history for the current user.
	 */	
	loadUserSearchHistory(): void {
	    this.searchService.getUserSearchHistory().then(
			(data: any) => {
		        this.searchHistory = data.slice(0, 1);
		        if ("Concept" === this.searchHistory[0]?.type) {
		            this.getConceptTerms(this.searchHistory[0].qs);
		        }
		    }, 
			() => {
		        this.searchHistory = [];
		    }
		);
	};

	/**
	 * Gets the expanded search concepts for the query terms.
	 */	
	getConceptTerms(terms: string): void {
	    this.searchService.getConceptsForTerms(terms).then(
			(data: any) => {
		        this.concepts = data;
		    }, 
			() => {
		        this.concepts = [];
		    }
		);
	};	
	
	/**
	 * Displays a help page.
	 */
	displayHelp(): void {
		var url = "~/../app/load/help/en/help.html";
		window.open(url, "_blank");		
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
